import React from "react";
import { 
  ChefHat, 
  Bed, 
  Bath, 
  Tv, 
  Wifi, 
  TreePine, 
  Utensils,
  Shirt,
  CookingPot,
  Target,
  Baby,
  Heart
} from "lucide-react";

const AmenitiesSectionEN = () => {
  const amenities = [
    {
      icon: ChefHat,
      title: "Equipped kitchen",
      description: "Everything you need to prepare your meals"
    },
    {
      icon: Bed,
      title: "3 bedrooms",
      description: "Comfortable bedding for optimal rest"
    },
    {
      icon: Bath,
      title: "3 bathrooms",
      description: "Modern and functional bathrooms"
    },
    {
      icon: Tv,
      title: "Television",
      description: "Family relaxation moments"
    },
    {
      icon: Wifi,
      title: "Free Wi-Fi",
      description: "High-speed internet connection"
    },
    {
      icon: TreePine,
      title: "Terrace & garden",
      description: "Outdoor spaces to enjoy nature"
    },
    {
      icon: Utensils,
      title: "Dishwasher",
      description: "Modern comfort for your stays"
    },
    {
      icon: Shirt,
      title: "Washing machine",
      description: "Perfect for extended stays"
    },
    {
      icon: CookingPot,
      title: "Barbecue",
      description: "Outdoor grilling"
    },
    {
      icon: Target,
      title: "Pétanque court",
      description: "Family entertainment and games"
    },
    {
      icon: Baby,
      title: "Baby equipment",
      description: "Baby bed & high chair on request"
    },
    {
      icon: Heart,
      title: "Pets welcome",
      description: "Your four-legged companions are welcome"
    }
  ];

  return (
    <section 
      id="amenities" 
      className="section-padding bg-[#EDE6DB]/20"
      aria-labelledby="amenities-title"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 
            id="amenities-title"
            className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-[#1C3A27] mb-4 md:mb-6"
          >
            Amenities & Comfort
          </h2>
          <p className="text-lg md:text-xl text-[#1C3A27]/70 max-w-3xl mx-auto leading-relaxed">
            Everything is designed for your well-being and comfort in our charming gîte
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {amenities.map((amenity, index) => {
            const IconComponent = amenity.icon;
            return (
              <div
                key={index}
                className="group card-hover bg-white rounded-xl p-4 sm:p-6 shadow-lg border border-[#EDE6DB]/50 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-[#1C3A27] transition-colors duration-300">
                    <IconComponent 
                      size={24} 
                      className="sm:w-8 sm:h-8 text-[#1C3A27] group-hover:text-white transition-colors duration-300" 
                    />
                  </div>
                  
                  <h3 className="font-semibold text-base sm:text-lg text-[#1C3A27] mb-2">
                    {amenity.title}
                  </h3>
                  
                  <p className="text-[#1C3A27]/70 text-sm leading-relaxed">
                    {amenity.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#EDE6DB]/50 max-w-4xl mx-auto">
            <h3 className="font-serif text-xl md:text-2xl font-bold text-[#1C3A27] mb-4 md:mb-6">
              Other included services
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 text-[#1C3A27]/80">
              <div className="text-center sm:text-left">
                <div className="font-semibold mb-1">Bed linen included</div>
                <div className="text-sm">Beds made on arrival (towels optional)</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="font-semibold mb-1">Free parking</div>
                <div className="text-sm">Immediately nearby</div>
              </div>
              <div className="text-center sm:text-left">
                <div className="font-semibold mb-1">Autonomous access</div>
                <div className="text-sm">Secure key box</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSectionEN;